const DEMO_HOSTNAME = 'demo.tst.datanomik.com';
const DEMO_BASE = 'https://backentira.vercel.app';

const isDemo = (): boolean => {
  try {
    return window.location.hostname.includes(DEMO_HOSTNAME);
  } catch {
    return false;
  }
};

export const getApiUrls = () => {
  if (isDemo()) {
    return {
      DASHBOARD_MGR_URL: `${DEMO_BASE}/v1/`,
      DASHBOARD_MGR_JWT_URL: `${DEMO_BASE}/jwt/`,
      DASHBOARD_MGR_API_URL: `${DEMO_BASE}/api/v1/`,
      DASHBOARD_API_URL: `${DEMO_BASE}/api/v1/`,
    };
  }

  return {
    DASHBOARD_MGR_URL: import.meta.env.VITE_DASHBOARD_MGR_URL as string,
    DASHBOARD_MGR_JWT_URL: import.meta.env.VITE_DASHBOARD_MGR_JWT_URL as string,
    DASHBOARD_MGR_API_URL: import.meta.env.VITE_DASHBOARD_MGR_API_URL as string,
    DASHBOARD_API_URL: import.meta.env.VITE_DASHBOARD_API_URL as string,
  };
};

const apiUrls = getApiUrls();

export default apiUrls;
